/**
 * **类名常量** —— 单一来源。
 *
 * 为什么要单独一个文件：`styles.ts`（写选择器）和几个组件（写 class）
 * 都得用同一批名字，而**写错一个字母不会有任何报错** ——
 * 症状是"样式没生效"，人眼分不出它和"设计就是这样"
 * （`verify:css` 的文件头记着三次同样的坑）。
 *
 * ⚠️ 前缀是 `npp-`（不是内核的 `np-`）：一眼能看出这段 DOM 是**包**画的。
 * 内核的 `verify:css` 只认 `np-` / `pg-` 开头的那两套（它统计的是
 * `src/**\/*.css` 与 `*.vue` 里的类），所以包这边的样式不受它管辖 ——
 * 这是**有意的**：包的样式归包自己（`node-packages.md` §4：包能贡献
 * **自己的**编辑器，但不往内核的 DOM 上长）。代价是这边的死类没人查，
 * 所以类名集中在这里，改的时候只改一处。
 */

/** 编辑器主体的根类名 */
export const PRINT_EDITOR_CLASS = 'npp'
/** 侧栏面板的根类名 */
export const PRINT_PANEL_CLASS = 'npp-p'

/** `npp` / `npp-p` 下的子元素类名（`__` 连接） */
export const cls = (part: string): string => `${PRINT_EDITOR_CLASS}__${part}`
/** 与 `cls` 对称的面板侧 */
export const pcls = (part: string): string => `${PRINT_PANEL_CLASS}__${part}`
